/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, createSettingsUsageResponseFromDiscriminatorValue, type HttpValidationProblemDetails, type IError, type SettingsUsageResponse } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /settings/usage
 */
export interface UsageRequestBuilder extends BaseRequestBuilder<UsageRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<SettingsUsageResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<UsageRequestBuilderGetQueryParameters> | undefined) : Promise<SettingsUsageResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<UsageRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface UsageRequestBuilderGetQueryParameters {
    endDate?: Date;
    startDate?: Date;
}
/**
 * Uri template for the request builder.
 */
export const UsageRequestBuilderUriTemplate = "{+baseurl}/settings/usage{?endDate*,startDate*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const UsageRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: UsageRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createSettingsUsageResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
